/* tslint:disable */
/* eslint-disable */
/**
 * fantasy-dynasty-app
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { NflPlayerGameStatistics } from '../model';
/**
 * PlayerGameApi - axios parameter creator
 * @export
 */
export const PlayerGameApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve Player weekly stats current week
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerForCurrentWeek: async (playerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('getPlayerForCurrentWeek', 'playerId', playerId)
            const localVarPath = `/games/player/{playerId}/weekly_stats`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve player stats for a specific season and year
         * @param {string} playerId 
         * @param {number} week 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerStatsByWeekAndYear: async (playerId: string, week: number, year: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('getPlayerStatsByWeekAndYear', 'playerId', playerId)
            // verify required parameter 'week' is not null or undefined
            assertParamExists('getPlayerStatsByWeekAndYear', 'week', week)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getPlayerStatsByWeekAndYear', 'year', year)
            const localVarPath = `/games/player/{playerId}/week/{week}/season/{year}/weekly_stats/`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)))
                .replace(`{${"week"}}`, encodeURIComponent(String(week)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Load all player stats for a specific year
         * @param {string} playerId 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerStatsByYear: async (playerId: string, year: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('getPlayerStatsByYear', 'playerId', playerId)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getPlayerStatsByYear', 'year', year)
            const localVarPath = `/games/player/{playerId}/season/{year}/weekly_stats/`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlayerGameApi - functional programming interface
 * @export
 */
export const PlayerGameApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlayerGameApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieve Player weekly stats current week
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayerForCurrentWeek(playerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NflPlayerGameStatistics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayerForCurrentWeek(playerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve player stats for a specific season and year
         * @param {string} playerId 
         * @param {number} week 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayerStatsByWeekAndYear(playerId: string, week: number, year: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NflPlayerGameStatistics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayerStatsByWeekAndYear(playerId, week, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Load all player stats for a specific year
         * @param {string} playerId 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayerStatsByYear(playerId: string, year: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NflPlayerGameStatistics>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayerStatsByYear(playerId, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlayerGameApi - factory interface
 * @export
 */
export const PlayerGameApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlayerGameApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieve Player weekly stats current week
         * @param {string} playerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerForCurrentWeek(playerId: string, options?: any): AxiosPromise<NflPlayerGameStatistics> {
            return localVarFp.getPlayerForCurrentWeek(playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve player stats for a specific season and year
         * @param {string} playerId 
         * @param {number} week 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerStatsByWeekAndYear(playerId: string, week: number, year: number, options?: any): AxiosPromise<NflPlayerGameStatistics> {
            return localVarFp.getPlayerStatsByWeekAndYear(playerId, week, year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Load all player stats for a specific year
         * @param {string} playerId 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerStatsByYear(playerId: string, year: number, options?: any): AxiosPromise<Array<NflPlayerGameStatistics>> {
            return localVarFp.getPlayerStatsByYear(playerId, year, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlayerGameApi - object-oriented interface
 * @export
 * @class PlayerGameApi
 * @extends {BaseAPI}
 */
export class PlayerGameApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve Player weekly stats current week
     * @param {string} playerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerGameApi
     */
    public getPlayerForCurrentWeek(playerId: string, options?: AxiosRequestConfig) {
        return PlayerGameApiFp(this.configuration).getPlayerForCurrentWeek(playerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve player stats for a specific season and year
     * @param {string} playerId 
     * @param {number} week 
     * @param {number} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerGameApi
     */
    public getPlayerStatsByWeekAndYear(playerId: string, week: number, year: number, options?: AxiosRequestConfig) {
        return PlayerGameApiFp(this.configuration).getPlayerStatsByWeekAndYear(playerId, week, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Load all player stats for a specific year
     * @param {string} playerId 
     * @param {number} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerGameApi
     */
    public getPlayerStatsByYear(playerId: string, year: number, options?: AxiosRequestConfig) {
        return PlayerGameApiFp(this.configuration).getPlayerStatsByYear(playerId, year, options).then((request) => request(this.axios, this.basePath));
    }
}
